module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABRUExURR4eHh0dHR4eHh8fHx8fHxsbGxcXF0dwTB4eHh8fHxoaGh8fHxgYGB8fHx4eHh0dHR0dHR4eHh8fHx8fHx4eHh4eHh4eHh0dHR8fHx4eHh8fHy/Hck4AAAAadFJOU/1oZvLTExYAZ88UxxXMyVBOTHXg4k13cnMREGyqPgAAAHpJREFUGNNV0dkOgzAMRNFhq4HShZ3m/z+0SUgmth+PbOlKxqepxcz0egq+QK/x0bq3QCrDHofOq+EbgypOGJWc8dbExKSRC2YNvBGpcji3ZqT6c1cCUZKW0g3V2ZOhO8nQ8WRoJMNgZowGI9eCy2Lgxu+eP/sh2Wf5A2paDGJCX28EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img20.png
// module id = JGfS
// module chunks = 1